const fctGeneral = {
    install(Vue) {
        //Permet de copier un objet sans conserver d'instance
        Vue.prototype.$CObj =  function(payLoad) {
            return JSON.parse(JSON.stringify(payLoad));
        }
        //Obtenir la date actuel
        Vue.prototype.$gDate =  function() {
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            //today = mm + '/' + dd + '/' + yyyy;
            today = yyyy + '-' + mm + '-' + dd;
            return today;
        }
        //Obtenir si la date de fin est inférieur à la date de début alors on retourne la date de début
        Vue.prototype.$gDateEndMoreDateStart =  function(endDate, startDate) {
            if(endDate < startDate)
            {
                return startDate;
            }
            else
            {
                return endDate;
            }
        }
        //Obtenir si la date de fin est inférieur à la date de début alors on retourne la date de début
        Vue.prototype.$gAccountYearAdd =  function(getDate) {
            if(getDate)
            {
               var moment = require('moment'); // require
               //var sendDate = new Date(getDate)

               return moment(getDate).add(1, 'year').subtract(1, 'days').format('YYYY-MM-DD');
            }
            else
            {
                return ''
            }
        }
        //Obtenir si la date de fin est inférieur à la date de début alors on retourne la date de début
        Vue.prototype.$gAccountYear =  function(getDate) {
            if(getDate)
            {
               var moment2 = require('moment'); // require
               //var sendDate = getDate

               return moment2(getDate).format('YYYY-MM-DD');
            }
            else
            {
                return ''
            }
        }
        //Obtenir si la date de fin est inférieur à la date de début alors on retourne la date de début
        Vue.prototype.$gShortDate =  function(getDate) {
            if(getDate)
            {
                var moment2 = require('moment'); // require
                //var sendDate = getDate

                return moment2(getDate).format('YYYY-MM-DD');
            }
            else
            {
                return ''
            }
        }

        //Mettre la premiere lettre en majuscule
        Vue.prototype.$gFirstUpper =  function(formSurname) {
            if (formSurname) {
                formSurname = formSurname.toString()
                return formSurname.charAt(0).toUpperCase() + formSurname.slice(1).toLowerCase()
            }
            return ""
        }



    }
}
    
export default fctGeneral